// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"fcb66131","241":"20d8a1d2","383":"50529501","545":"81b3eae0","704":"386089de","722":"eed1fc2e"}[chunkId] + ".chunk.js";
};